import React, { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

export const LoginInput = ({ id, type, disabled, icon, classname, placeholder, autoComplete, required = false }) => {
  const [visible, setVisible] = useState(false);
  const password = type === "password";
  const toggle = () => { if (!disabled) setVisible(current => !current); };
  return (
    <div className="inputType2Container">
      <div className={`input-container${password ? " loginPasswordField" : ""}`}>
        <input id={id} type={password && visible ? "text" : type}
          name={id} required={required} placeholder={placeholder} autoComplete={autoComplete || (type === "email" ? "email" : "off")} disabled={disabled} className={`inputType2 ${classname}`} />
        {password ? (
          <button type="button" className="inputRight loginPasswordToggle" disabled={disabled}
            aria-label={visible ? "Ocultar contraseña" : "Mostrar contraseña"}
            aria-pressed={visible} aria-controls={id} onClick={toggle}
            onKeyDown={event => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                toggle();
              }
            }}>
            {visible ? <AiOutlineEye aria-hidden="true" /> : <AiOutlineEyeInvisible aria-hidden="true" />}
          </button>
        ) : <span className="inputRight" aria-hidden="true">{icon}</span>}
      </div>
    </div>
  );
};
